import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './Common/css/blueTheme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from "react-redux";
import store from './Common/store.js'
import { applyBrandTheme } from './Common/config/brandConfig';

applyBrandTheme(document.documentElement);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// PWA 서비스워커 등록 (앱용, 전체 도메인 기준)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // 실패해도 앱 동작에는 영향 없음
    });
  });
}
